import { getDeliveryDateRange } from '~/js/lib/date';

export default (node) => {
  const minDays = parseInt(node.dataset.minDays, 10) || 2;
  const maxDays = parseInt(node.dataset.maxDays, 10) || 5;
  const dateFormat = node.dataset.dateFormat || 'dd/MM';
  const label = node.dataset.label || '';

  const dateRangeEl = node.querySelector('[data-delivery-date-range]');
  if (!dateRangeEl) return;

  try {
    const range = getDeliveryDateRange(minDays, maxDays, dateFormat);
    dateRangeEl.textContent = label ? `${label}: ${range}` : range;
  } catch {
    node.classList.add('hidden');
  }
};
